import { FormattedMessage, defineMessages } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { LabelM } from '@sorare/core/src/atoms/typography';
import { MLB_MARKET_PRIMARY } from '@sorare/core/src/constants/__generated__/routes';

import { useEvents } from '@sorare/gameplay/src/hooks/useEvents';

import { LeaderboardHighlight } from 'components/lobby/Leaderboards/LeaderboardHighlight';

const Description = styled(LabelM)`
  line-height: 1.2;
  color: var(--c-blue-400);

  &:focus,
  &:hover {
    color: var(--c-blue-300);
  }
`;

const messages = defineMessages({
  description: {
    id: 'MajorsLeaderboardHighlight.description',
    defaultMessage: 'Limited Cards get a {bonus}% bonus in {leaderboard}.',
  },
  cta: {
    id: 'MajorsLeaderboardHighlight.cta',
    defaultMessage: 'See available cards',
  },
});

export const MajorsHighlight = () => {
  const track = useEvents();
  const navigate = useNavigate();

  const onClick = () => {
    track('Click Player Cards Available See All', {
      interaction_context: 'lobby',
      value: 'lobby_majors_upsell',
    });
    navigate(`${MLB_MARKET_PRIMARY}?rarity=limited`);
  };

  return (
    <LeaderboardHighlight
      message={
        <FormattedMessage
          {...messages.description}
          values={{
            leaderboard: 'Majors',
            bonus: 40,
          }}
        />
      }
      lightColor="var(--c-reward-900)"
      darkColor="var(--c-reward-200)"
      cta={
        <button type="button" onClick={onClick}>
          <Description bold>
            <FormattedMessage {...messages.cta} />
          </Description>
        </button>
      }
    />
  );
};
